import {mapActions, mapGetters, mapMutations} from "vuex";
import {Carousel, Slide} from 'vue-carousel';
import productCard from "@/components/product-card/index.vue"

export default {
    name: "product-slider",
    props: {
        card: {
            type: String,
            default: ''
        }
    },
    components: {
        Carousel,
        Slide,
        productCard
    },
    data() {
        return {
        }
    },
    created() {
        this.fetchLatestProducts()
    },
    computed: {
        ...mapGetters({
            latestProducts: 'home/productData'
        })
    },
    methods: {
        ...mapMutations({}),
        ...mapActions({
            fetchLatestProducts: 'home/LATEST_PRODUCTS'
        }),
        carouselNav($event, direction) {
            const carousel = this.$refs['carousel'];
            carousel.advancePage(direction);
        },
    }
}


